import React from 'react';
import CheckoutForm from './CheckoutForm';

const CheckoutWrapper = () => <CheckoutForm />;

export default CheckoutWrapper;
